
import React, { createContext, useState, useContext, useEffect } from 'react';

// Create Context
const ReputationTasksContext = createContext();

// Provider Component
export const ReputationTasksProvider = ({ children }) => {
    // State to track processing task IDs
    // We use a Set for O(1) lookups, ensuring fast UI updates
    const [processingTasks, setProcessingTasks] = useState(new Set());

    // Function to start a task (optimistic UI update)
    const startTask = (taskId) => {
        setProcessingTasks(prev => {
            const newSet = new Set(prev);
            newSet.add(taskId);
            return newSet;
        });
        console.log(`[ReputationTasks] Task Started: ${taskId}`);
    };

    // Function to complete a task (remove from processing)
    const completeTask = (taskId) => {
        setProcessingTasks(prev => {
            const newSet = new Set(prev);
            newSet.delete(taskId);
            return newSet;
        });
        console.log(`[ReputationTasks] Task Completed: ${taskId}`);
    };

    // Helper to check if a task is actively processing
    const isProcessing = (taskId) => {
        return processingTasks.has(taskId);
    };

    return (
        <ReputationTasksContext.Provider value={{
            processingTasks,
            startTask,
            completeTask,
            isProcessing
        }}>
            {children}
        </ReputationTasksContext.Provider>
    );
};

// Custom Hook for easy access
export const useReputationTasks = () => {
    const context = useContext(ReputationTasksContext);
    if (!context) {
        throw new Error("useReputationTasks must be used within a ReputationTasksProvider");
    }
    return context;
};
